import { axiosbaseurl } from 'configure';
import React, { useEffect, useMemo, useState } from 'react'
import ReactApexChart from 'react-apexcharts';

const ServiceTasks = () => {

    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getServicesTasks = async () => {
            try {
                setLoading(true)
                const response = await axiosbaseurl.get("/reports/service-task/count");
                setServices(response.data.data || [])
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        getServicesTasks()
    }, [])

    // const services = [
    //     {
    //         id: 1,
    //         name: "Self-Assessment Tax Return",
    //         count: 8
    //     },
    //     {
    //         id: 2,
    //         name: "Confirmation Statement",
    //         count: 3
    //     },
    //     {
    //         id: 3,
    //         name: "Partnership Tax Return",
    //         count: 14
    //     },
    //     {
    //         id: 4,
    //         name: "Bookkeeping",
    //         count: 5
    //     },
    //     {
    //         id: 5,
    //         name: "Management Accounts",
    //         count: 6
    //     },
    //     {
    //         id: 6,
    //         name: "VAT Return",
    //         count: 11
    //     }
    // ]

    const graph_props = useMemo(() => (
        {

            series: [{
                name: '',
                data: services.map(s => s.taskCount)
            }],
            options: {
                chart: {
                    type: 'bar',
                    height: 450,
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '50%',
                        borderRadius: 5,
                        borderRadiusApplication: 'end'
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ["#30845d"],
                },
                xaxis: {
                    labels: {
                        rotate: -52
                    },
                    categories: services.map(s => s.serviceName),
                },
                yaxis: {
                    title: {
                        text: 'No. of tasks'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " Tasks"
                        }
                    }
                },
                colors: ['#40a676']
            }
        }
    ))


    return (
        <div>
            <div>
                <h5 className='text-dark fw-semibold'>Services Wise Tasks Report</h5>
            </div>

            <div className='mb-5'>
                <div>
                    <div id="chart ">
                        <ReactApexChart options={graph_props?.options || []} series={graph_props?.series || []} type="bar" height={350} />
                    </div>
                    <div id="html-dist"></div>
                </div>
            </div>
            <div className='pt-5 mt-5'>
                <table className='table table-bordered'>
                    <thead className='table-primary'>
                        <tr>
                            <th>ID</th>
                            <th>Service Name</th>
                            <th>Number of tasks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            services.map(item => (
                                <tr key={item.serviceNameId}>
                                    <td>{item.serviceNameId}</td>
                                    <td>{item.serviceName}</td>
                                    <td>{item.taskCount > 10 ? item.taskCount : `0${item.taskCount}`}</td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ServiceTasks